export function decodeJwt(token) {
  try {
    const payload = token.split(".")[1];
    if (!payload) return null;
    const base64 = payload.replace(/-/g, "+").replace(/_/g, "/");
    const json = atob(base64);
    return JSON.parse(json);
  } catch (_) {
    return null;
  }
}

export function buildUserFromToken(token) {
  const claims = decodeJwt(token);
  if (!claims) return null;

  const companyId = claims.companyId ?? claims.company_id ?? null;
  const employeeId = claims.employeeId ?? claims.employee_id ?? claims.sub ?? null;
  const departmentId = claims.departmentId ?? claims.department_id ?? null;
  const email = claims.email || claims.user_email || "";
  const permissions = Array.isArray(claims.permissions) ? claims.permissions : [];
  const roleRaw = claims.role || claims.role_key || claims.user_role || "UNKNOWN";
  const role = typeof roleRaw === "string" ? roleRaw.toUpperCase() : roleRaw;

  let firstName = claims.first_name || claims.firstName || "";
  let lastName = claims.last_name || claims.lastName || "";
  if (!firstName && !lastName && claims.name) {
    const parts = String(claims.name).split(" ");
    firstName = parts.shift() || "";
    lastName = parts.join(" ");
  }
  if (!firstName && !lastName && employeeId) {
    firstName = String(employeeId);
  }

  return {
    companyId,
    employeeId,
    departmentId,
    permissions,
    role,
    email,
    first_name: firstName || "",
    last_name: lastName || "",
    displayName: [firstName, lastName].filter(Boolean).join(" ") || email || "",
  };
}

export function storeAuthFromToken(token) {
  if (!token) return null;
  const user = buildUserFromToken(token);
  if (!user) return null;
  localStorage.setItem("token", token);
  localStorage.setItem("user", JSON.stringify(user));
  return user;
}

export function hasPermission(user, permission) {
  if (!user || !permission) return false;
  if (user.role === "CEO") return true;
  const perms = Array.isArray(user.permissions) ? user.permissions : [];
  return perms.map((p) => String(p).toLowerCase()).includes(String(permission).toLowerCase());
}
